// extracted by mini-css-extract-plugin
export default {"image":"L4-z","loaded":"M4-z"};